import { render, staticRenderFns } from "./ImgTips.vue?vue&type=template&id=d8da2f58&"
import script from "./ImgTips.vue?vue&type=script&lang=js&"
export * from "./ImgTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports